import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/customer-ticket";

export const pagingCustomerTicket = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getCustomerTicketById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveCustomerTicket = obj => axios.post(API_PATH + '/save-or-update', obj);

export const deleteCustomerTicket = id => axios.delete(API_PATH + '/mark-delete/' + id)

export const submitComment = obj => axios.post(API_PATH + '/save-or-update-ticket-comment', obj);

